<script>
import baseMixin from '@/mixins/baseMixin'
import { ContentField } from '@/models/forms/fields/contentField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionContentField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: ContentField,
      required: true,
    },
    value: {},
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <div v-sanitized-html="field.html" />
    </InfoLabel>
  </div>
</template>
